/** @format */

import { createSlice } from '@reduxjs/toolkit';

const toolsModificationSlice = createSlice({
  name: "toolsModification",
  initialState: {
    currBoxSize: null,
    updatedBoxSize: null,
    currVariable: null,
    fontSize: 10,
    fontFamily: "Georgia",
    width: null,
    height: null,
    toggleButton: false,
    dragToggleButton: false,
    textToggleButton:false,
    eraseToggleButton:false,
    imageToggleButton:false,
    replaceToggleButton:false,
    shapeToggleButton:false,
    fontSpace: 1,
    textCase: "lowercase",
  },
  reducers: {
    currentBoxSize(state, action) {
      const { payload } = action;
      return { ...state, currBoxSize: payload };
    },
    updateBoxSize(state, action) {
      const { payload } = action;
      return { ...state, updatedBoxSize: payload };
    },
    selectVariable(state, action) {
      const { payload } = action;
      const { height, width } = payload;
      if (state.toggleButton) {
        return {
          ...state,
          currVariable: payload,
          fontSize: state.fontSize,
          updatedBoxSize: { height, width },
        };
      } else {
        return { ...state, currVariable: payload, fontSize: state.fontSize };
      }
    },
    updateSelectVariable(state, action) {
      const { payload } = action;
      if (payload?.fontSize) {
        return {
          ...state,
          fontSize: payload?.fontSize,
          currVariable: { ...state.currVariable, ...payload },
          choosedVariable:{...state.currVariable, ...payload}
        };
      } else if (payload?.fontFamily) {
        return {
          ...state,
          fontFamily: payload?.fontFamily,
          currVariable: { ...state.currVariable, ...payload },
        };
      } else if (payload?.fontSpace) {
        return {
          ...state,
          fontSpace: payload?.fontSpace,
          currVariable: { ...state.currVariable, ...payload },
        };
      } else if (payload?.textCase) {
        return {
          ...state,
          textCase: payload?.textCase,
          currVariable: { ...state.currVariable, ...payload },
        };
      } else {
        return {
          ...state,
          currVariable: { ...state.currVariable, ...payload },
        };
      }
    },
    handleToggleButton(state, action) {
      const { payload } = action;
      return { ...state, toggleButton: payload };
    },
    handleDragToggleButton(state, action) {
      const { payload } = action;
      return { ...state, dragToggleButton: payload };
    },
    handleTextToggleButton(state, action) {
      const { payload } = action;
      return { ...state, textToggleButton: payload };
    },
    handleEraseToggleButton(state, action) {
      const { payload } = action;
      return { ...state, eraseToggleButton: payload };
    },
    handleImageToggleButton(state, action) {
      const { payload } = action;
      return { ...state, imageToggleButton: payload };
    },
    handleReplaceToggleButton(state, action) {
      const { payload } = action;
      return { ...state, replaceToggleButton: payload };
    },
    handleShapeToggleButton(state, action) {
      const { payload } = action;
      return { ...state, shapeToggleButton: payload };
    },
    clearAllToolModificationData() {
      return {
        currBoxSize: null,
        updatedBoxSize: null,
        currVariable: null,
        fontSize: 10,
        fontFamily: "Georgia",
        fontSpace: 1,
        width: null,
        height: null,
        toggleButton: false,
        dragToggleButton: false,
        textToggleButton:false,
        eraseToggleButton:false,
        replaceToggleButton:false,
        shapeToggleButton:false,
        textCase: "lowercase",
      };
    },
  },
});

export const {
  currentBoxSize,
  updateBoxSize,
  selectVariable,
  handleToggleButton,
  handleDragToggleButton,
  handleTextToggleButton,
  handleEraseToggleButton,
  handleImageToggleButton,
  handleReplaceToggleButton,
  handleShapeToggleButton,
  updateSelectVariable,
  clearAllToolModificationData,
} = toolsModificationSlice.actions;
export default toolsModificationSlice.reducer;
